import {type MutationTree} from 'vuex';

const mutations: MutationTree<IPersonalDashboardState> = {
    init(state, open)
    {
        state.isOpen = open;
    },
    set(state, open)
    {
        state.isOpen = open;
    },
};

export default mutations;